/**
 * Labstep
 *
 * @module state/new/sidebar
 * @desc Selectors/Reducers for Sidebar
 */

import type { Action } from 'redux';

export type StateSidebar = {
  [key: string]: boolean;
};

type ISetSidebarActionType = {
  type: 'SIDEBAR_SET';
  key: string;
  visible: boolean;
};

export type ISetSidebarActionCreatorType = (
  visible: boolean,
  key: string,
) => ISetSidebarActionType;

export const setSidebarActionCreator: ISetSidebarActionCreatorType = (
  visible,
  key,
) => ({
  type: 'SIDEBAR_SET',
  key,
  visible,
});

export const sidebar = (
  state = {},
  action: Action | ISetSidebarActionType,
): StateSidebar => {
  if (action.type === 'SIDEBAR_SET') {
    return {
      ...state,
      [(action as ISetSidebarActionType).key]: (
        action as ISetSidebarActionType
      ).visible,
    };
  }
  return state;
};

export const sidebarReducer = sidebar;
